/*eslint-disable strict */
import "./polyfills";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './app';
import Config from './config';
import Analytics from './analytics';
import TranslatesProvider from "./translatesProvider";
require('es6-promise').polyfill();

Analytics.sendEvent('Bathroom-Visualizer-Loaded');
window.resetMixpanelId = () => Analytics.logOutMixPanel();

ReactDOM.render(
  <Provider store={store}>
    <TranslatesProvider>
      <App/>
    </TranslatesProvider>
  </Provider>,
  document.getElementById('app')
);

window.resetKiosk = function () {
  if (parent && document.kvConfig.kioskMode) {
    if (parent.window.resetKiosk) {
      Config.parent.window.resetKiosk();
    }
  }
};
